import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { FunctionComponent } from 'react';
import { ColorPalette } from 'shared/consts/colorPalette';
import { showErrorNotification } from 'shared/helpers/showErrorNotification';
import { useCountdown } from 'shared/helpers/useCountdown';
import { StatusModal } from 'widgets/auth/_common/ui/StatusModal';
import { sendConfirmationEmail } from 'entities/Auth/api';
import { useSignInStore } from 'widgets/auth/signUp/_MainModal/model/state';

export const SUEmailSentModal: FunctionComponent = () => {
	const { emailToSend } = useSignInStore();
	const [timeLeft, setCountdown] = useCountdown('/sign-up/email-sent');
	const { t } = useTranslation();

	const handleSendConfirmationEmail = () => {
		sendConfirmationEmail({ email: emailToSend })
			.then((res) => {
				if (res?.data?.success) {
					setCountdown(120);
				}
			})
			.catch((err) => {
				showErrorNotification(err);
			});
	};

	return (
		<StatusModal
			type={'info'}
			title={t('auth.status_modal.email_confirm')}
			message={t('auth.status_modal.email_confirm_message')}
		>
			<Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'center' }}>
				<Typography variant={'body2'} color={ColorPalette.astronaut}>
					{t('auth.status_modal.dont_receive_confirmation_email')}
				</Typography>
				{timeLeft ? (
					<Typography variant={'body2'} color={ColorPalette.royalBlue} sx={{ marginLeft: '8px' }}>
						{timeLeft.minutes}:{timeLeft.seconds}
					</Typography>
				) : (
					<Typography
						variant={'body2'}
						color={ColorPalette.royalBlue}
						sx={{ cursor: 'pointer', marginLeft: '8px' }}
						onClick={handleSendConfirmationEmail}
					>
						{t('auth.status_modal.resend')}
					</Typography>
				)}
			</Box>
		</StatusModal>
	);
};
